module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/main-visual@3x-149726b77e789b768e693bbadd93cb85.webp";